// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ConfluenceLogo } from '@atlaskit/logo';
import { N300, N30A } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { ANALYTICS_CHANNEL } from '../analytics';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
  fontSize: 12,
  height: 52,
  color: `var(--ds-text-subtle, ${N300})`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderTop: `2px solid ${`var(--ds-border, ${N30A})`}`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
  height: 16,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LogoWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: `0px 0px 0px ${"var(--ds-space-100, 8px)"}`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Link = styled.a({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&, &:focus, &:active, &:hover': {
    color: 'inherit',
    outline: 'none',
    boxShadow: 'none',
    textDecoration: 'none'
  }
});
export const Footer = ({
  url,
  linkTooltip,
  label
}) => /*#__PURE__*/React.createElement(Container, {
  "data-testid": "footer-container"
}, url ? /*#__PURE__*/React.createElement(ContentAction, {
  tooltipText: linkTooltip,
  href: url
}, ({
  isHovered
}) => /*#__PURE__*/React.createElement(Content, {
  isHovered: isHovered,
  label: label
})) : /*#__PURE__*/React.createElement(Content, {
  label: label
}));
const Content = ({
  isHovered,
  label
}) => /*#__PURE__*/React.createElement(ContentWrapper, null, label, /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(ConfluenceLogo, {
  appearance: isHovered ? 'brand' : 'neutral',
  size: "xsmall"
})));
const ContentAction = ({
  children,
  tooltipText,
  href
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const handleClick = () => {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'confluenceFooter',
      source: 'embeddedConfluenceViewPageScreen',
      eventType: 'ui'
    }).fire(ANALYTICS_CHANNEL);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipText
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    target: "_blank",
    onMouseEnter: () => {
      setIsHovered(true);
    },
    onMouseLeave: () => {
      setIsHovered(false);
    },
    onClick: handleClick,
    "data-testid": "link"
  }, children({
    isHovered
  })));
};